import React from "react";
import {ASSET_TYPE} from "components/Layout/constants";
import AssetItemInfo from "../AssetItemInfo";
import useHandleAssetInfo from "../hooks/useHandleAssetInfo";
import ListTypeItemThumbnail from "../ListTypeItemThumbnail";

function ListTypeItem({data, uploadProgress}) {
  const {handleAssetThumbnail} = useHandleAssetInfo();
  const isSound = data?.topCategory === ASSET_TYPE.SOUND;

  return (
    <AssetItemInfo data={data}>
      <ListTypeItemThumbnail
        asset={data}
        uploadProgress={uploadProgress}
        thumbnail={handleAssetThumbnail(data)}
        name={data?.name}
        duration={data?.duration}
        appearance={{
          hasNoPlayButton: !isSound,
        }}
      />
    </AssetItemInfo>
  );
}

export default ListTypeItem;
